import { useEffect } from "react";
import { EVENT } from "../lib/site";

export const Seo = ({ title, description, path = "" }) => {
  useEffect(() => {
    const full = title ? `${title}, ${EVENT.name}` : EVENT.name;
    document.title = full;
    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const desc = description || "A family-friendly charity Turkey Trot in Grimsby, ON supporting Inclusion West Niagara.";
    setMeta("description", desc);
    setMeta("og:title", full, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", "website", "property");
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${window.location.origin}${path}`);
  }, [title, description, path]);
  return null;
};
